import React from 'react';
import WeatherCloudSvg from '!!svg-react-loader!../../../../assets/images/pages/ice/fields/weather-cloud.svg';
import WeatherRainySvg from '!!svg-react-loader!../../../../assets/images/pages/ice/fields/weather-rain.svg';
import WeatherSunnySvg from '!!svg-react-loader!../../../../assets/images/pages/ice/fields/weather-sun.svg';

export default class Constants {
  static WEATHER_SUNNY = 0;
  static WEATHER_CLOUDY = 1;
  static WEATHER_RAINY = 2;
  static WEATHERS = [Constants.WEATHER_SUNNY, Constants.WEATHER_CLOUDY, Constants.WEATHER_RAINY];
  static WEATHER_LABELS = ['はれ', 'くもり', 'あめ'];
  static WEATHER_LABELS_ICE_ADV = ['晴れ', 'くもり', '雨'];

  static PLACE_ZOO = 0;
  static PLACE_OFFICE_STREAT = 1;
  static PLACE_SHOPPING_MALL = 2;
  static PLACES = [Constants.PLACE_ZOO, Constants.PLACE_OFFICE_STREAT, Constants.PLACE_SHOPPING_MALL];
  static PLACE_LABELS = ['どうぶつえん', 'かいしゃの まえ', 'ショッピングモール'];
  static PLACE_LABELS_ADV = ['動物園', '会社の前', 'ショッピングモール'];

  static SIMULATION_TIME_MSEC = 30 * 1000;

  static ICE_BANANA = 0;
  static ICE_CHOCO = 1;
  static ICE_VANILLA = 2;
  static ICE_STRAWBERRY = 3;
  static ICES = [Constants.ICE_BANANA, Constants.ICE_CHOCO, Constants.ICE_VANILLA, Constants.ICE_STRAWBERRY];
  static ICE_LABELS = ['バナナ', 'チョコ', 'バニラ', 'イチゴ'];

  static WAGON_MAN = 0;
  static WAGON_CHILD = 1;
  static WAGON_WOMAN = 2;
  static WAGONS = [Constants.WAGON_MAN, Constants.WAGON_CHILD, Constants.WAGON_WOMAN];
  static WAGON_LABELS = ['かわいいワゴン', 'かっこいいワゴン', 'おしゃれなワゴン'];

  static MIN_TEMPERATURE = 15;
  static MAX_TEMPERATURE = 35;

  static MIN_PRICE = 50;
  static MAX_PRICE = 250;
  static PRICE_STEP = 10;
  static DEFAULT_PRICE = 100;

  static STOCK_NUM = 100;

  static CUSTOMER_MAN = 0;
  static CUSTOMER_WOMAN = 1;
  static CUSTOMER_CHILD = 2;
  static CUSTOMER_LABELS = ['おとな(おとこ)', 'おとな(おんな)', 'こども'];
  static CUSTOMER_LENGTH = 3;

  static START_HOUR = 10;
  static END_HOUR = 18;

  static ZOO_BASE_CUSTOMERS_NUM = [25, 30, 35, 35, 30, 30, 20, 20];
  static OFFICE_BASE_CUSTOMERS_NUM = [20, 25, 35, 35, 25, 25, 30, 30];
  static SHOPPING_MALL_BASE_CUSTOMERS_NUM = [20, 20, 25, 35, 35, 30, 30, 30];

  static BORDER_COLORS = ['rgba(254,97,132,0.5)', 'rgba(54,164,235,0.5)', 'rgba(255, 206, 86, 0.5)'];
  static BACKGROUND_COLORS = ['rgba(254,97,132,0.5)', 'rgba(54,164,235,0.5)', 'rgba(255, 206, 86, 0.5)'];

  static WEEKDAY_SUNDAY = 0;
  static WEEKDAY_MONDAY = 1;
  static WEEKDAY_TUESDAY = 2;
  static WEEKDAY_WEDNESDAY = 3;
  static WEEKDAY_THURSDAY = 4;
  static WEEKDAY_FRIDAY = 5;
  static WEEKDAY_SATURDAY = 6;
  static WEEKDAYS = [
    Constants.WEEKDAY_SUNDAY,
    Constants.WEEKDAY_MONDAY,
    Constants.WEEKDAY_TUESDAY,
    Constants.WEEKDAY_WEDNESDAY,
    Constants.WEEKDAY_THURSDAY,
    Constants.WEEKDAY_FRIDAY,
    Constants.WEEKDAY_SATURDAY,
  ];
  static WEEKDAYS_ICE_ADV = [
    Constants.WEEKDAY_SUNDAY,
    Constants.WEEKDAY_MONDAY,
    Constants.WEEKDAY_TUESDAY,
    Constants.WEEKDAY_WEDNESDAY,
    Constants.WEEKDAY_THURSDAY,
    Constants.WEEKDAY_FRIDAY,
    Constants.WEEKDAY_SATURDAY,
  ];
  static WEEKDAY_LABELS = [
    'にちようび',
    'げつようび',
    'かようび',
    'すいようび',
    'もくようび',
    'きんようび',
    'どようび',
  ];
  static WEEKDAY_LABELS_ICE_ADV = ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日'];

  static getRandomWeather() {
    return Constants.WEATHERS[Constants.getRandomInt(Constants.WEATHERS.length)];
  }

  static getRandomWeekday() {
    return Constants.WEEKDAYS[Constants.getRandomInt(Constants.WEEKDAYS.length)];
  }

  /*
   * Saturday and Sunday must be included.
   */
  static getRandomWeekdays() {
    const WEEKDAYS_CANDIDATES = [
      [0, 1, 2, 3],
      [6, 0, 1, 2],
      [5, 6, 0, 1],
      [4, 5, 6, 0],
      [3, 4, 5, 6],
    ];
    return WEEKDAYS_CANDIDATES[Constants.getRandomInt(WEEKDAYS_CANDIDATES.length)];
  }

  static getPlaceIcons() {
    return Constants.PLACES.map(function(v) {
      return `../../images/pages/ice/fields/icon-place${v}.png`;
    });
  }

  static getPlaceIcon(place) {
    return `../../images/pages/ice/fields/icon-place${place}.png`;
  }

  static getIceImages() {
    return Constants.ICES.map(function(v) {
      return `../../images/pages/ice/fields/img-ice${v}.png`;
    });
  }

  static getIceImage(ice) {
    return `../../images/pages/ice/fields/img-ice${ice}.png`;
  }

  static getWagonIcons() {
    return Constants.WAGONS.map(function(v) {
      return `../../images/pages/ice/fields/icon-wagon${v}.png`;
    });
  }

  static getWagonIcon(wagon) {
    return `../../images/pages/ice/fields/icon-wagon${wagon}.png`;
  }

  static getStatusWagonIcon(wagon) {
    return `../../images/pages/ice/fields/ice_field_icon_wagon${wagon}.png`;
  }

  static getWagonIcon2(wagon) {
    return `../../images/pages/ice/fields/img_ice_field_wagon${wagon}.png`;
  }

  static getWagonImage(wagon, soldout = false) {
    if (soldout) {
      return `../../images/pages/ice/fields/img-wagon-soldout-${wagon}.png`;
    } else {
      return `../../images/pages/ice/fields/img-wagon${wagon}.png`;
    }
  }

  static getWagonImageAdv(wagon, soldout = false) {
    if (soldout) {
      return `../../images/pages/ice-a/fields/img-wagon-soldout-${wagon}.png`;
    } else {
      return `../../images/pages/ice/fields/img-wagon${wagon}.png`;
    }
  }

  static getSoldoutImage(wagon) {
    return `../../images/pages/ice/fields/img-soldout-${wagon}.png`;
  }

  static getSoldoutImageAdv(wagon) {
    return `../../images/pages/ice-a/fields/img-soldout-${wagon}.png`;
  }

  static getStartImage(avatar) {
    return `../../images/pages/ice/fields/ice_field_start_${avatar}@3x.png`;
  }

  static getWagonAvatarImage(avatar = 1) {
    return `../../images/pages/ice/fields/fi_ice_select-wagon_avatar_me${avatar}@3x.png`;
  }

  static getCommentImage(avatar) {
    return `../../images/pages/ice/fields/ice_comment_${avatar}@3x.png`;
  }

  static getWetherSvg(weather) {
    if (weather == Constants.WEATHER_SUNNY) {
      return <WeatherSunnySvg />;
    } else if (weather == Constants.WEATHER_CLOUDY) {
      return <WeatherCloudSvg />;
    } else {
      return <WeatherRainySvg />;
    }
  }

  static getRandomTemperature() {
    return Constants.MIN_TEMPERATURE + Constants.getRandomInt(Constants.MAX_TEMPERATURE - Constants.MIN_TEMPERATURE);
  }

  static getRandomTemperatures() {
    let results = [];
    results.push(15 + Constants.getRandomInt(5));
    results.push(20 + Constants.getRandomInt(5));
    results.push(25 + Constants.getRandomInt(5));
    results.push(30 + Constants.getRandomInt(5));
    for (let i = results.length - 1; i > 0; i--) {
      let r = Math.floor(Math.random() * (i + 1));
      let tmp = results[i];
      results[i] = results[r];
      results[r] = tmp;
    }
    return results;
  }

  static getRandomInt(max) {
    return Math.floor(Math.random() * Math.floor(max));
  }
}
